"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "villa-carcina": {
    "b23d957a": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "cailina": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d125fa44": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "carcina": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43dcf08e": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f1bdd58f": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "cogozzo": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "60d61fcc": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "pregno": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6179c669": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2acbe9ad": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "skipSearch": false
    }],
    "zignone": [{
      "hkey": "d96e53dd",
      "slug": "villa-carcina",
      "name": "Villa Carcina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;